import Cookies from "js-cookie";
export const jsonSafeGet = (jsonString, defaultData = {}) => {
    let output = defaultData;
    try {
        output = JSON.parse(jsonString);
    }
    catch (e) {
        // do nothing.
    }
    return output;
};
const getCookies = () => {
    var _a;
    const data = {
        tgtTimestamp: jsonSafeGet(Cookies.get('auth')).t || Cookies.get('tgt_timestamp'),
        tgtTicket: jsonSafeGet(Cookies.get('auth')).k || Cookies.get('tgt_ticket'),
        device_uuid: (_a = Cookies.get('device_uuid')) !== null && _a !== void 0 ? _a : '',
    };
    return data;
};
const defaultOptions = Object.assign({ expires: process.env.REACT_APP_DEFAULT_COOKIES_EXPIRED_IN_MINUTES, path: "/" }, (typeof window !== "undefined"
    ? window.location.hostname.includes("localhost")
        ? { domain: window.location.hostname }
        : {
            domain: "." +
                window.location.hostname.split(".").reverse()[1] +
                "." +
                window.location.hostname.split(".").reverse()[0],
        }
    : {}));
const setCookie = (name, value, options) => {
    // Default values for options:
    let { expires = "", path = "/", domain = "" } = options;
    // If expires is a number, convert it to minutes and create a Date object:
    if (typeof expires === "number") {
        const minutes = expires;
        const now = new Date();
        now.setTime(now.getTime() + minutes * 60 * 1000);
        expires = now;
    }
    // Construct the cookie string:
    let cookieString = `${name}=${value}`;
    if (expires instanceof Date) {
        cookieString += `;expires=${expires.toUTCString()}`;
    }
    if (path) {
        cookieString += `;path=${path}`;
    }
    if (domain) {
        cookieString += `;domain=${domain}`;
    }
    // Set the cookie:
    document.cookie = cookieString;
};
export { getCookies, setCookie, defaultOptions };
